/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LootboxTransactionPagination
 */
export interface LootboxTransactionPagination {
    /**
     * Total number of LootBox purchases
     * @type {number}
     * @memberof LootboxTransactionPagination
     */
    total?: number;
    /**
     * Number of transactions per page
     * @type {number}
     * @memberof LootboxTransactionPagination
     */
    limit?: number;
    /**
     * Starting offset
     * @type {number}
     * @memberof LootboxTransactionPagination
     */
    offset?: number;
    /**
     * Whether more transactions exist
     * @type {boolean}
     * @memberof LootboxTransactionPagination
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the LootboxTransactionPagination interface.
 */
export function instanceOfLootboxTransactionPagination(value: object): value is LootboxTransactionPagination {
    return true;
}

export function LootboxTransactionPaginationFromJSON(json: any): LootboxTransactionPagination {
    return LootboxTransactionPaginationFromJSONTyped(json, false);
}

export function LootboxTransactionPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxTransactionPagination {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function LootboxTransactionPaginationToJSON(json: any): LootboxTransactionPagination {
    return LootboxTransactionPaginationToJSONTyped(json, false);
}

export function LootboxTransactionPaginationToJSONTyped(value?: LootboxTransactionPagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
        'hasMore': value['hasMore'],
    };
}

